import { createPostFetch } from '../../../lib/createFetch';
import { SendMessageReq } from '../../../pages/api/customers/find-a-supplier';
import { SendMessageRes } from '../../../pages/api/customers/find-a-supplier';

export const sendTelegramMsg = createPostFetch<SendMessageReq, SendMessageRes>(
    '/api/customers/find-a-supplier'
);
